import * as yup from 'yup';

const schema = () =>
  yup.object().shape({
    ccpaDoNotSellPersonalInfo: yup.boolean().nullable(),
  });

export default schema;
